
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppSelect, AppInput, AppButton } from '@/components';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { useAccountActivity } from '@/modules/account/app/model/activity';
import { ActivityFilterType, AccountAppOptions } from '@/modules/account/app/model/mixins';
import { useAccountAppMixins, useAccountActions } from '@/modules/account/app/model/mixins';
import { ROUTE_NAME_ACCOUNT } from '@/modules/account/router';

export default defineComponent({
    name: ROUTE_NAME_ACCOUNT.APP.ACTIVITY,
    components: { AppTable, AppCard, AppFormRow, AppSelect, AppInput, AppButton },
    setup() {
        const { query, accountId, isBanned, v$, list, total, fetchList } = useAccountActivity();
        const { routerLink } = useAccountAppMixins();
        const actions = useAccountActions(() => fetchList());

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Account ID', key: 'accountId' },
                { type: TableColumnType.Text, label: 'Device ID', key: 'deviceId' },
                { type: TableColumnType.Text, label: 'IP Address', key: 'ipAddress' },
                { type: TableColumnType.Text, label: 'Platform', key: 'platform' },
                { type: TableColumnType.Text, label: 'Device OS', key: 'deviceOS' },
                { type: TableColumnType.Option, label: 'Store', key: 'store', options: AccountAppOptions.Store },
                { type: TableColumnType.Text, label: 'Version', key: 'version' },
                { type: TableColumnType.DateTime, label: 'Create Time', key: 'createTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: row => ({
                        icon: 'fa-map-marker-alt',
                        theme: 'info',
                        tooltip: 'Filter by address',
                        to: routerLink.activity(ActivityFilterType.IpAddress.value, row.ipAddress)
                    }),
                    group: 0
                },
                {
                    props: row => ({
                        icon: 'fa-tablet-alt',
                        theme: 'info',
                        tooltip: 'Filter by device',
                        to: routerLink.activity(ActivityFilterType.DeviceId.value, row.deviceId)
                    }),
                    group: 1
                }
            ]
        };

        onMounted(fetchList);

        return {
            query,
            accountId,
            isBanned,
            list,
            total,
            v$,
            table,
            fetchList,
            actions,
            AccountAppOptions,
            ActivityFilterType
        };
    }
});
